import React, { Component } from 'react';
import { generate } from 'shortid';
import FieldGroup from './FieldGroup';
import { DoorOpenNumberValidation } from '../../tools/Validations';

class DoorOpenNumberField extends Component {
  constructor(props) {
    super(props);
    this.id = generate();
    this.validation = props.validation || new DoorOpenNumberValidation();
    this.validation.test(props.value);
  }

  render() {
    let { value } = this.props;
    return (
      <FieldGroup
        id={this.id}
        name="doorOpenNumber"
        type="number"
        min={0}
        max={9}
        label="Grant guest access digit"
        value={value}
        onChange={this.onChange}
        onBlur={this.validate}
        validation={this.validation}
        help="When the buzzer calls you, what digit do you press to grant guest access? If you are unsure, please ask your building manager."
        placeholder="e.g. 6" />
    );
  }

  onChange = (e) => {
    let value = String(e.target.value);
    let isValid = this.validation.test(value);
    let onChange = this.props.onChange;
    if (onChange) {
      onChange(e, isValid);
    }
  }
}

export default DoorOpenNumberField;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/DoorOpenNumberField.js